// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"36":"acf6540e46a3b544","817":"739a4557785eb378","875":"6b6258b4c18f771e"}[chunkId] + ".js";
};